"use strict";import{tag as a}from"../custom-tag.js";export function selectionIcon({height:e=16,width:t=16,hidden:l=!1,title:s="Selection"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${s}"
    >
      <mask
        id="selection_svg__mask0_6875_6576"
        width="13"
        height="20"
        x="6"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="m12.43 21.895 5.77-6.365-.48-.53-5.53 6.1-5.51-6.08-.48.53 5.75 6.345a.34.34 0 0 0 .24.105c.09 0 .176-.038.24-.105m-.46-19.79L6.2 8.47l.48.53 5.53-6.1 5.51 6.08.48-.53-5.75-6.345A.33.33 0 0 0 12.21 2a.33.33 0 0 0-.24.105"
        />
      </mask>
      <g mask="url(#selection_svg__mask0_6875_6576)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=selection.js.map
